function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPocChurchFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 18a2 2 0 100-4 2 2 0 000 4z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 2h-2v3h-3v2h3v2l-8 8v2.79l-4 3.578V30h26v-6.632l-4-3.578V17l-8-8V7h3V5h-3V2zM9 17.828V28h3v-8h8v8h3V17.828l-7-7-7 7zm-4 6.435l2-1.79V28H5v-3.737zm20-1.79V28h2v-3.737l-2-1.79zM18 22v6h-4v-6h4z",
    fill: props.color
  }));
}

export default SvgIconPocChurchFilled;